import { useLocation, useNavigate } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAr = localStorage.getItem("diyafa_lang") === "ar";

  return (
    <div
      className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-cream"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-9xl md:text-[12rem] font-black text-line select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10 flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-ink flex items-center justify-center mb-2">
          <i className="ri-door-open-line text-white text-2xl"></i>
        </div>
        <h1 className={`text-xl md:text-2xl font-bold text-ink ${isAr ? "font-tajawal" : "font-inter"}`}>
          {isAr ? "الصفحة غير موجودة" : "Page Not Found"}
        </h1>
        <p className="text-sm text-muted font-mono">{location.pathname}</p>
        <p className={`text-base text-muted max-w-sm ${isAr ? "font-tajawal" : ""}`}>
          {isAr
            ? "هذه الصفحة غير موجودة أو تم نقلها."
            : "This page doesn't exist or has been moved."}
        </p>
        <button
          onClick={() => navigate("/")}
          className={`mt-2 px-6 py-3 rounded-xl bg-gold text-ink font-semibold text-sm cursor-pointer hover:bg-gold-dark transition-colors whitespace-nowrap ${isAr ? "font-tajawal" : ""}`}
        >
          {isAr ? "العودة للرئيسية" : "Back to Home"}
        </button>
      </div>
    </div>
  );
}
